export default __webpack_public_path__ + "static/media/lera.b7b4456f.svg";